import clsx from "clsx";
import React, { useRef, useState } from "react";

import { Icon } from "./Icon";

export const FileField = ({
  onChange,
  fileTypes,
  size = "md",
  className,
}: {
  onChange: (files: FileList) => void;
  fileTypes?: string[];
  size?: "sm" | "md" | "lg";
  className?: string;
  value?: FileList;
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [isDragOver, setIsDragOver] = useState(false);

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
      onChange(files);
    }
  };

  const handleDrop = (event: React.DragEvent) => {
    event.preventDefault();
    setIsDragOver(false);
    const files = event.dataTransfer.files;
    if (files && files.length > 0) {
      onChange(files);
    }
  };

  const handleDragOver = (event: React.DragEvent) => {
    event.preventDefault();
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  return (
    <div
      className={clsx(
        "relative w-full flex items-center justify-center",
        "rounded-lg transition-all duration-200 border-2 border-dashed",
        {
          "h-32": size === "sm",
          "h-40": size === "md",
          "h-52": size === "lg",
          "border-brand dark:border-brand-light bg-brand/10 dark:bg-brand/20": isDragOver,
          "border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-800/50": !isDragOver,
        },
        className,
      )}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      style={{ cursor: "pointer" }}
    >
      <div className="absolute flex flex-col items-center justify-center gap-2 w-full h-full top-0 left-0 pointer-events-none">
        <Icon
          name="upload"
          size={size === "lg" ? 32 : size === "md" ? 24 : 20}
          className="text-gray-400 dark:text-gray-500"
        />
        <span className="text-xs text-gray-500 dark:text-gray-400">Drag & Drop File</span>
        <span className="text-xs text-gray-500 dark:text-gray-400">- or -</span>
        <span className="text-xs text-gray-500 dark:text-gray-400">Click to Select File</span>
      </div>
      <input
        ref={fileInputRef}
        type="file"
        accept={fileTypes ? fileTypes.map((t) => "." + t).join(",") : undefined}
        onChange={handleFileSelect}
        className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
        tabIndex={-1}
        style={{ pointerEvents: "auto" }}
      />
    </div>
  );
};
